const ja = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title': 'ソース名の検出',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'ユーザー ID',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'Service Now URL',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'パスワード',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': '無効な URL',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': '検出の頻度',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'ナレッジベース認証 (KBA) の質問に回答するようにユーザーに促します。',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'これらの一般的な検出ソースのいずれかを使用して、アプリとワークロードを検出します。事前に入力された詳細、優先順位付けされた推奨事項、オンボーディング ステータスの完全な表示などの利点があります。',
  'INTEGRATIONS.DISCOVERY.BACK': '戻る',
  'INTEGRATIONS.DISCOVERY.TITLE': '検出の設定',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': '間もなく公開...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': '詳細情報',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'アプリケーションの資格情報を入力して、接続を確立します。接続が成功すると、データをインポートできるようになります。',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'ページのロード中に問題が発生しました。',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    '更新するか、後でもう一度確認してください。この問題が解決しない場合は管理者にお問い合わせください。',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'リロード',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title': '接続設定',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'CI クラス***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title': '属性マッピング',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title': '接続の詳細',
  'INTEGRATIONS.BUTTON.SAVE': '保存',
  'INTEGRATIONS.DISCOVERY.SELECT': '選択',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': '新しい接続の作成',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'この接続を使用',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow を保存しました',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    '検出ソース ServiceNow への接続が正常にテストされ、保存されました。データをインポートして検出の設定を完了します。スキップできます ...',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'アセットのインポート',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': '今はスキップする',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    '一度インポートを開始すると、キャンセルできません',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'ガイド',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': '既存の接続の選択',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': '接続名',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    '{total, plural, one {} other {#}} 件の既存の接続の構成:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'インポートの開始',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Excel ファイルからデータをインポートします。お待ちください...',
  'INTEGRATIONS.TRY.AGAIN': 'もう一度お試しください',
  'INTEGRATIONS.CLOSE': '閉じる',
  'INTEGRATIONS.ERROR.CONNECTION': '接続エラーです。もう一度お試しください。',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    '待機中にページを終了できます。処理が完了したらお知らせします。',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': '検出ソースのインポート',
  'INTEGRATIONS.FILEUPLOAD.HEADING': 'ファイルから検出ソースをインポート',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'サンプル ファイルのダウンロード',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'ソース名の検出',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'ファイル名の入力',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    '有効なファイル名を入力してください。文字、数字、一部の記号のみを使用できます。',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'アップロード中...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': '続行',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'アップロード済みの XLSX ファイルの最初の 10 件のレコードを示します。',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    '必須ヘッダーがありません',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    '列エラーを検出しました',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'データのインポートに進む前に、問題を修正してください。',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'インポートから除外',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'アプリケーション オンボーディング確認',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'アプリケーション タイプを特定しました。オンボーディングするアプリケーション タイプが正しいかどうかを確認してください。',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'オンボーディングするアプリケーション タイプは {applicationName} です',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'いいえ、アプリケーション リストから選択します',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    'はい、オンボーディング中です',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': '統合',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': '統合の追加',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': '結果は見つかりませんでした:',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'いいえ',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': '統合が見つかりました。',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN': '隠れた統合はありません。',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED':
    '検出されたアプリケーション',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': '所有者:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': '最終検出日',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': '接続に失敗しました',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'ユーザーにアクセスがある',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': '検出ソース',
  'INTEGRATIONS.BUTTON.ENABLE': '有効化',
  'INTEGRATIONS.BUTTON.DISABLE': '無効化',
  'INTEGRATIONS.ENABLING': '有効化中',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': '検出',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': '再アップロード',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'オンボード',
  'INTEGRATIONS.DASHBOARD.HIDE': '非表示',
  'INTEGRATIONS.DASHBOARD.UNHIDE': '表示',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': '検出構成タブ',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    '未保存の変更を破棄しますか?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    '未保存の変更があります。続行すると変更は失われます。',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': '変更を破棄',
  'INTEGRATIONS.BUTTON.CANCEL': 'キャンセル',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': '保存エラー',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL': '前のページに戻る',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'アプリケーション アイコン',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': '手動で実行',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE': '無効化に失敗',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': '有効化に失敗',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    '正常に無効化しました。',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    '正常に有効化しました。',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    '別のインポートが現在進行中です。',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'アセットは現在、別のプロセスでインポートされています。後でもう一度お試しください。',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED':
    'インポートに失敗しました',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS':
    'ServiceNow からアセットをインポートしています',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    '待機中にページを終了できます。処理が完了したらお知らせします。',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    '新しい属性マッピング行を追加',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': '属性の追加',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(空)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'このマッピングを削除',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'ServiceNow フィールド',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Saviynt フィールド',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW': 'ServiceNow 属性の検索',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': 'Saviynt 属性の検索',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(カスタム)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': '保存に失敗しました',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'スケジュールの構成',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': '{timeLabel} (UTC)。',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': '繰り返し',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': '繰り返し日数',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': '繰り返し間隔',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL': '間隔を入力',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    '繰り返し間隔 (日数、週数、月数)',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': '日',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': '週',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': '月',
  'INTEGRATIONS.DAYS.SUN': '日',
  'INTEGRATIONS.DAYS.MON': '月',
  'INTEGRATIONS.DAYS.TUE': '火',
  'INTEGRATIONS.DAYS.WED': '水',
  'INTEGRATIONS.DAYS.THU': '木',
  'INTEGRATIONS.DAYS.FRI': '金',
  'INTEGRATIONS.DAYS.SAT': '土',
  'INTEGRATIONS.BUTTON.DISABLING': '無効化中',
  'INTEGRATIONS.BUTTON.SAVED': '保存済み',
  'INTEGRATIONS.BUTTON.SAVING': '保存中',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE': '無効にしますか ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    '検出ソースを無効にするとアセットのインポートが停止し、ソースを構成できなくなります。',
  'INTEGRATIONS.DISCOVERY.HERE': 'こちら',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    '検出ソースは正常に作成されましたが、ServiceNow への接続に失敗しました。アセットのインポートを開始するには、検出ソース構成ページで接続の詳細を更新してください ',
};

export default ja;
